module.exports = __webpack_public_path__ + "img/extension1.a49a9c42.jpg";